import Header from './components/Header';
import Footer from './components/Footer';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState, useContext } from 'react';
import Modal from "react-modal";
import IMask from 'imask';
import { setSessionCookie, getSessionCookie, SessionContext } from '../Cookies';
import { Helmet } from 'react-helmet';

function Login() {
  let navigate = useNavigate();
  const [modalIsOpen, setModalOpen] = useState(false);
  const [modalValue, setModalValue] = useState("Signup Successful!");
  const [loginLoading, setLoginLoading] = useState(false);
  const [modalCloseFunction, setModalCloseFunction] = useState("redirect");
  const session = useContext(SessionContext);

  useEffect(() => {
    document.title = "Sign Up | Riverland Technology Services";
    if(session)
    {
        navigate("/");
    }
    var phonemask = IMask(document.getElementById("phoneInput"), {
        mask: [
            {
                mask: '0400 000 000'
            },
            {
                mask: '(00) 0000 0000'
            },
            {
                mask: '+00 000 000 000'
            }
        ]
    });

    var abnMask = IMask(document.getElementById("abnInput"), {
        mask: [
            {
                mask: '00 000 000 000'
            }
        ]
    });
  }, []);

  function signup()
  {
      setLoginLoading(true);
      const firstName = document.getElementById("firstNameInput").value;
      const lastName = document.getElementById("lastNameInput").value;
      const phoneNumber = document.getElementById("phoneInput").value;
      const email = document.getElementById("emailInput").value;
      const password = document.getElementById("passwordInput").value;
      const organisationName = document.getElementById("organisationInput").value;
      const ABN = document.getElementById("abnInput").value;
      const hcaptcha = document.getElementById("h-captcha").children[0].getAttribute("data-hcaptcha-response");
      const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ firstName: firstName, lastName: lastName, phoneNumber: phoneNumber, email: email, password: password, organisationName: organisationName, abn: ABN, hcaptcha: hcaptcha })
      };
      fetch('https://riverlandtech.au/api/v1/account/signup.php', requestOptions)
          .then(response => response.json())
          .then((data) => {
                  if(data.status == "success")
                  {
                    setModalOpen(true);
                    setModalCloseFunction("redirect");
                  }
                  else if(data.error == "email_taken")
                  {
                    setModalValue("Email already used!");
                    setModalOpen(true);
                    setLoginLoading(false);
                    setModalCloseFunction("close");
                  }
                  else if(data.error == "general")
                  {
                    setModalValue("General error!");
                    setModalOpen(true);
                    setLoginLoading(false);
                    setModalCloseFunction("close");
                  }
                  else if(data.error == "captcha_failed")
                  {
                    setModalValue("Captcha Failed!");
                    setModalOpen(true);
                    setLoginLoading(false);
                    setModalCloseFunction("close");
                  }
                  else
                  {
                    setModalValue("Unknown error!");
                    setModalOpen(true);
                    setLoginLoading(false);
                    setModalCloseFunction("close");
                  }
              });
  }

  function closeModal()
  {
      if(modalCloseFunction == "redirect")
      {
          navigate("/login");
      }
      else
      {
          setModalOpen(false);
      }
  }

  return (
    <>
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            contentLabel="Enquiry successfully sent"
            appElement={document.getElementById('home')}
            >
            <section
                className="section ProductHeroSection WebDevProductHeroSection HeroSection Section--hasGuides theme--light accent--Blue">
                <div className="section_masked">
                    <div className="section_backgroundMask">
                        <div className="section_background">
                            <div className="guides hero-guides">
                                <div className="guidesContainer">
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sectionContainer">
                        <div className="sectionLayoutContainer">
                            <div className="sectionLayout">
                                <div className="RowLayout ProductHeroSection_layout">
                                    <div className="ProductHeroSection_content">
                                        <div className="RowLayout">
                                            <section className="Copy variant--Hero">
                                                <header className="Copy_header">
                                                    <h1 className="CopyTitle">
                                                        {modalValue}
                                                    </h1>
                                                </header>
                                                <footer className="Copy_footer">
                                                    <div className="Copy_footerContainer">
                                                        <button
                                                            onClick={closeModal} className="CtaButton variant--Button CtaButton--arrow HomepageHero_cta enquireBtn">
                                                            Close
                                                            <svg className="HoverArrow" width="10" height="10"
                                                                 viewBox="0 0 10 10" aria-hidden="true">
                                                                <g fill-rule="evenodd">
                                                                    <path className="HoverArrow__linePath"
                                                                          d="M0 5h7"></path>
                                                                    <path className="HoverArrow__tipPath"
                                                                          d="M1 1l4 4-4 4"></path>
                                                                </g>
                                                            </svg>
                                                        </button>
                                                    </div>
                                                </footer>
                                            </section>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Modal>
        <Helmet>
            <script src={"https://js.hcaptcha.com/1/api.js?cacheupdater=" + new Date().getTime()} async defer></script>
        </Helmet>
      <Header theme="dark" accent="Blue" />
        <section className="section ProductHeroSection WebDevProductHeroSection HeroSection Section--hasGuides theme--dark accent--Blue">
            <div className="section_masked">
                <div className="section_backgroundMask">
                    <div className="section_background">
                        <div className="guides hero-guides">
                            <div className="guidesContainer">
                                <div className="guides-guide"></div>
                                <div className="guides-guide"></div>
                                <div className="guides-guide"></div>
                                <div className="guides-guide"></div>
                                <div className="guides-guide"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="sectionContainer">
                    <div className="sectionLayoutContainer">
                        <div className="sectionLayout">
                            <div className="RowLayout ProductHeroSection_layout">
                                <nav className="ProductNav">
                                    <header className="ProductNav_header">
                                        <h1 className="ProductNav_title">Sign Up</h1>
                                    </header>
                                </nav>
                                <div className="ProductHeroSection_content">
                                    <div className="RowLayout">
                                        <section className="Copy variant--Hero">
                                            <div>
                                                <section className="enquireForm">
                                                    <div className="formContainer">
                                                        <form action="#" method="post">
                                                            <ul className="formList">
                                                                <li className="formItem"><div className="formLabelContainer"><span className="formLabel">First Name</span></div><div className="formInputContainer"><input className="formInput" type="text" name="firstNameInput" id="firstNameInput" placeholder="John" required /></div></li>
                                                                <li className="formItem"><div className="formLabelContainer"><span className="formLabel">Last Name</span></div><div className="formInputContainer"><input className="formInput" type="text" name="lastNameInput" id="lastNameInput" placeholder="Doe" required /></div></li>
                                                                <li className="formItem"><div className="formLabelContainer"><span className="formLabel">Phone Number</span></div><div className="formInputContainer"><input className="formInput" type="text" name="phoneInput" id="phoneInput" placeholder="(xx) xxxx xxxx/+xx xxx xxx xxx" required /></div></li>
                                                                <li className="formItem"><div className="formLabelContainer"><span className="formLabel">Email Address</span></div><div className="formInputContainer"><input className="formInput" type="email" name="emailInput" id="emailInput" placeholder="john@atom.tech" required /></div></li>
                                                                <li className="formItem"><div className="formLabelContainer"><span className="formLabel">Password</span></div><div className="formInputContainer"><input className="formInput" type="password" name="passwordInput" id="passwordInput" placeholder="********" required /></div></li>
                                                                <li className="formItem"><div className="formLabelContainer"><span className="formLabel">Organisation Name</span><span className="formLabelDescription">Optional</span></div><div className="formInputContainer"><input className="formInput" type="text" name="organisationInput" id="organisationInput" placeholder="Atom Technology Company" /></div></li>
                                                                <li className="formItem"><div className="formLabelContainer"><span className="formLabel">ABN</span><span className="formLabelDescription">Optional</span></div><div className="formInputContainer"><input className="formInput" type="text" name="abnInput" id="abnInput" placeholder="12 121 121 121" /></div></li>
                                                            </ul>
                                                            <div className="formFooter">
                                                                <div class="h-captcha" id="h-captcha" data-sitekey="4d7c46f1-ca4d-4a11-9094-f2b82c046a82"></div>
                                                                <button type="submit" name="submit" className="CtaButton variant--Button CtaButton--arrow HomepageHero_cta" onClick={signup} disabled={loginLoading} style={{height: "33px", marginLeft: "1rem"}}>
                                                                    Sign Up
                                                                    <svg class="HoverArrow" width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">
                                                                        <g fill-rule="evenodd">
                                                                            <path class="HoverArrow__linePath" d="M0 5h7"></path>
                                                                            <path class="HoverArrow__tipPath" d="M1 1l4 4-4 4"></path>
                                                                        </g>
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </section>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
      <Footer />
    </>
  );
}

export default Login;
